// extracted by mini-css-extract-plugin
module.exports = {"langSwitcher":"LangSwitcher_langSwitcher__VCJK_"};